import { useState, useRef, useEffect } from 'react';
import { useIsomorphicLayoutEffect } from '@shopify/react-hooks';
import { useKeyboardNavigationContext } from '../KeyboardNavigation.mjs';
import { Action } from '../types.mjs';
import { useUniqueId } from '../../../utilities/unique-id/hooks.mjs';

function useKeyboardNavigation({
  ref
}) {
  const context = useKeyboardNavigationContext();
  const id = useUniqueId();
  const [index, setIndex] = useState(-1);
  const indexRef = useRef(index);
  useEffect(function registerOnMount() {
    if (context == null) {
      return noop;
    }
    const {
      dispatch
    } = context;
    dispatch({
      type: Action.RegisterKeyboardNavigationOption,
      payload: {
        id,
        index: indexRef,
        node: ref
      }
    });
    return () => {
      dispatch({
        type: Action.UnregisterKeyboardNavigationOption,
        payload: {
          id
        }
      });
    };
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  useIsomorphicLayoutEffect(() => {
    if (context == null) {
      return;
    }
    const {
      options
    } = context;
    if (!options.current.includes(id)) {
      const newIndex = options.current.length;
      if (index !== newIndex) {
        setIndex(newIndex);
        indexRef.current = newIndex;
      }
      options.current = [...options.current, id];
    }
  });
  if (context == null) {
    return {};
  }
  const {
    state
  } = context;
  return {
    id,
    index,
    selected: state.selectedIndex === index
  };
}
function noop() {}

export { useKeyboardNavigation };
